import { secp256k1 } from "@noble/curves/secp256k1";
import { ed25519 } from "@noble/curves/ed25519";

export function generateSecp256k1Key(): Uint8Array {
  return secp256k1.utils.randomPrivateKey();
}

export function generateEd25519Key(): Uint8Array {
  return ed25519.utils.randomPrivateKey();
}
